import { api, wrappedCollectionFetcher } from "services/api.service";
import { defaultLocationTypeMovementCondition } from "types/locationManagement/locationTypeMovementCondition";
import { LocationManagementLocationType } from "types/locationManagement/locationType";
import { redirect } from "react-router-dom";
import { withActionErrorAlert } from "utils/withActionError";

export async function loader() {
  const locationTypesRes = await wrappedCollectionFetcher<LocationManagementLocationType>(
    "/location_management/location_types?page[size]=100",
  );
  const locationTypes = locationTypesRes.rows || [];
  return { condition: defaultLocationTypeMovementCondition, locationTypes };
}

export async function action({ request }: { request: Request }) {
  const formData = await request.formData();
  const res = await withActionErrorAlert(() =>
    api.request({
      method: "POST",
      url: `/location_management/location_type_movement_conditions`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  );
  if (res?.status === 201) {
    return redirect("/location-type-movement-conditions");
  }
  return res;
}
